<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 12:49:04
 * @LastEditTime: 2022-12-29 16:04:18
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page5-wrapper">
        <!-- <img class='right-start animate__animated  animate__pulse animate__infinite' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-05Rb9iQyRmcesWRHj.png"/> -->
        <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-419W9uz7XSyZYLRCE.png" class="hourglass animate__animated animate__rotateIn animate__infinite"/> -->
         <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-18-22p8PApTVblOIMAJl.png" class="title-image  animate__animated animate__fadeInRight"/> -->
        <div class="page5-content animate__animated animate__rotateIn">
            
            <div class="page5-main">
                <!-- <img class="left-start animate__animated  animate__pulse animate__infinite" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-04OwI56TWd56jzdhRYc.png"/> -->
                <!-- <img class='right-start animate__animated  animate__pulse animate__infinite' src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-05Rb9iQyRmcesWRHj.png"/> -->
                
           <span v-if="reportData.forumData.length">    
                    你管理的圈子<br>
                    <span v-for="(item, index) in reportData.forumData" :key="index">
                        <span class="report-num-text">{{ item.name }}</span>
                        <span v-if="index < reportData.forumData.length - 1" class="report-num">、</span>
                    </span><br>
                    2023圈内发文<span class="report-num"> {{ forumData.post }} </span>篇<br>
                    累计浏览量<span class="report-num"> {{ forumData.read }} </span>次<br>
                    <!-- 提供过精神食粮<br> -->
                    发文量超过了社区<br>
                    <span class="report-num"> {{ Math.floor(forumData.percentage * 100) }}% </span>的圈子<br>
                </span>
                <span v-else>
                    虽然你还没有圈子<br>
                    但过去一年社区<br>
                    <!-- 创建专栏<span class="report-num"> {{ reportData.community.forumCount }} </span>个<br> -->
                    成立圈子<span class="report-num"> {{ reportData.community.forumCount }} </span>个<br>
                    累计<span class="report-num"> 8729 </span>人关注<br>
                    <!-- “栏”出精耕细作的专题<br> -->
                    “圈”出丰富多彩的领域
                </span>
            </div>
            <!-- <div class="page-title">部门之光</div>
            <span>
                今年，你所在的部门<span class="report-num">{{shortDept}}</span><br>
                全年累计发文<span class="report-num"> {{ reportData.deptData.postNum }} </span>篇<br>
                成立圈子<span class="report-num"> {{ reportData.deptData.forums.length }} </span>个，专栏<span class="report-num"> {{ reportData.deptData.columns.length }} </span>个<br>
                参与讨论<span class="report-num"> {{ reportData.deptData.discussNum }} </span>次<br>
                浏览了<span class="report-num"> {{ reportData.deptData.readPostNum }} </span>篇文章<br>
                你在部门中贡献度排名第<span class="report-num"> {{ reportData.deptData.rank }}</span><br>
                <span v-if="reportData.deptData.rank > 1">贡献最多的同事是<span class="report-num">{{ reportData.deptData.maxUser }}</span><br></span>
                一个人的努力是加法<br>
                一个团队的努力是乘法
            </span> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page5',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
    //   shortDept() {
    //     const list = this.reportData.department.split('-')
    //     return list[list.length - 1]
    //   }
    forumData() {
            const res = {
                post: 0,
                read: 0,
                percentage: 0
            };
            for (let i = 0; i < this.reportData.forumData.length; i++) {
                const item = this.reportData.forumData[i];
                res.post += item.num;
                res.read += item.viewNum;
                res.percentage = item.percentage > res.percentage ? item.percentage.slice(0, 4) : res.percentage;
            }
            return res;
        },
    },
    methods: {
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page5-wrapper {
    height: 100vh;
    width: 100%;
    // padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-16Ty161616uS6ejfZpgf.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .page5-content {
        // padding-top: 80px;
        font-size: 0.4rem;
        line-height: 2.8;
        color: #FAFAD7;
        font-weight: bold;

        .page-title {
            width: 100px;
            color: #fff;
            background: #2D97E1;
            border-radius: 4px;
            margin-bottom: 40px;
            font-weight: 500;
            line-height: 1;
            padding: 6px 0;
            position: relative;
            text-align: center;

            &:after {
                position: absolute;
                display: block;
                content: '';
                width: 300px;
                height: 4px;
                bottom: -4px;
                border-radius: 4px;
                background: #D9F0F9;
            }
        }
    }

    .report-num {
        color: #f1f406;
        font-weight: 500;
        font-size: 0.55rem;
    }
    .report-num-text {
       color: #f1f406;
        font-weight: 500;
        font-size: 0.45rem; 
    }

    .page5-main {
        // width: 80%;
        // border-radius: 8px;
        margin: 3.5rem auto 0;
        padding: 0 24px;
        // min-height: 45vh;
        // background-image: linear-gradient(#6577F8, #A0BDF4, #DEE5F2, );
        position: relative;
        // box-sizing: border-box;

        .left-start {
            position: absolute;
            left: -1rem;
            top: -1rem;
            transform: translate(-50%, -50%);
            width: 2rem;
            height: 2rem;

        }

        
    }

    @keyframes rotoImg {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .hourglass {
        animation: rotoImg 3s linear infinite;
        position: absolute;
        bottom: 48px;
        right: 24px;
        width: 1.5rem;
        height: 1.5rem;
        z-index: 10;
    }

    .title-image {
        height: 1.3rem;
        margin-top: 10vh;
    }
    .right-start {
            position: absolute;
            top: 1.5rem;
            right: 1.2rem;
            width: 1.5rem;
            height: 1.5rem;
        }
         
}
@media screen and (min-width: 1980px) {
            #page5-wrapper {
                .page5-main {
                    margin-top: 24vh;
                }
            }
            }
</style>
